export const STABLE_CURRENCIES = [
  'USDC', 'USDT', 'BUSD', 'HUSD', 'DUSD', 'TUSD'
];
